import React from "react";
import Dropdown from "react-bootstrap/lib/Dropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";

const SuggestionsDropdown = ({ onSelect, suggestions = [], toggle, active, styles = {} }) => {
  const renderSuggestions = () => {
    if (suggestions.length) {
      return suggestions.map(({ value, text }) => (
        <MenuItem
          {...(MenuItem.defaultProps || {})}
          key={`drop-down-suggestion-${text}`}
          eventKey={value}
          className="dropdown-item text-decoration-none py-2 px-3"
          onClick={(e) => {
            e.preventDefault();
            onSelect(value);
          }}
        >
          {text}
        </MenuItem>
      ));
    } else {
      return (
        <MenuItem {...(MenuItem.defaultProps || {})} eventKey={null}>
          <span className="no-suggestions">No Suggestions</span>
        </MenuItem>
      );
    }
  };

  const onToggle = (isOpen, _event, { source }) => {
    !isOpen && source === "rootClose" && toggle();
  };
  if (active) {
    return (
      <Dropdown
        {...(Dropdown.defaultProps || {})}
        id="suggestions-dropdown"
        className={`${styles.suggestionsDropdown}`}
        defaultOpen={false}
        open={active}
        onToggle={onToggle}
      >
        <Dropdown.Menu {...(Dropdown.Menu.defaultProps || {})}>{renderSuggestions()}</Dropdown.Menu>
      </Dropdown>
    );
  }
  return null;
};

export default SuggestionsDropdown;
